export default __webpack_public_path__ + "static/media/new-cta-link-active.13344e1b.svg";